import type { Handler } from './handler';
import type { DeviceFingerprintPort } from './ports/device-fingerprint.port';
import { resolveAdapter } from '~/adapters/registry';
import { tryCatch } from '~/utils/apostatudo/try-catch';

export const generateDeviceFingerprintHandler: Handler<
  undefined,
  Ports,
  Promise<string | null>
> = async (
  ports = {
    deviceFingerprint: resolveAdapter('deviceFingerprint'),
  },
) => {
  if (!import.meta.client) {
    return null;
  }

  const [fingerprint, fingerprintError] = await tryCatch(
    ports.deviceFingerprint.generate(),
  );

  if (fingerprintError) {
    console.error(
      '[generateDeviceFingerprintHandler] Error generating device fingerprint:',
      fingerprintError,
    );

    return null;
  }

  return fingerprint;
};

type Ports = { deviceFingerprint: DeviceFingerprintPort };
